<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>
Murder on the Cliffs</title><link href="css/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="css/page-template.xpgt" rel="stylesheet" type="application/adobe-page-template+xml"/>
<div class="body">
<p class="copyright1">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="copyright-space">MURDER ON THE CLIFFS. Copyright © 2009 by Joanna Challis. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="copyright-space"><a href="http://www.minotaurbooks.com" target="_blank">www.minotaurbooks.com</a></p>
<p class="copyright-space">Library of Congress Cataloging- in- Publication Data</p>
<p class="copyright-space">Challis, Joanna.</p>
<p class="copyright2">Murder on the cliffs : a Daphne Du Maurier mystery / Joanna Challis.—1st ed.</p>
<p class="copyright3">p. cm.</p>
<p class="copyright2">ISBN 978-0-312-36714-5</p>
<p class="copyright4">1. Du Maurier, Daphne, 1907—1989—Fiction.2. Women authors, English—20th century—Fiction.3. Drowning victims—Fiction.4. Murder—Investigation— Fiction.5. Aristocracy (Social class)—England—Cornwall—Fiction. 6. Mansions—England—Cornwall—Fiction.7. Cornwall (England)—Fiction. I. Title.</p>
<p class="copyright2">PR9619.4.C39M87 2009</p>
<p class="copyright2">823.92—dc22</p>
<p class="copyright-space1">2009028463</p>
<p class="copyright-space">First Edition: December 2009</p>
<p class="copyright-space">10   9   8   7   6   5   4   3   2   1</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?3ebc8142